/**
 * Picture renditions that live beside an original on the CDN.
 *
 * A rendition URL names its own width: `<name>.w1200.webp` is the gallery's
 * size; `<name>.w480.webp` and `<name>.w720.webp` sit beside it for a card —
 * 720 because a half-screen phone card at 3x needs ~620px. The API hands out the
 * 1200 one. A URL that does not name a rendition has no siblings — an ordinary
 * upload — so nothing here may invent one: a `srcset` entry that points at a
 * file that is not there is a broken picture.
 *
 * See `utils/__tests__/aCardFetchesACardSizedPicture.test.js`.
 */
const RENDITION = /^(.*)\.w1200\.webp$/;

/** `srcset` offering the 480 and 720 siblings and the 1200 original, or undefined. */
export function renditionSrcSet(url) {
  const m = typeof url === 'string' ? RENDITION.exec(url) : null;
  if (!m) return undefined;
  return `${m[1]}.w480.webp 480w, ${m[1]}.w720.webp 720w, ${url} 1200w`;
}

/** The sibling at `width` (480) for a rendition URL; any other URL unchanged. */
export function renditionUrl(url, width) {
  const m = typeof url === 'string' ? RENDITION.exec(url) : null;
  if (!m || width !== 480) return url;
  return `${m[1]}.w480.webp`;
}
